const VALID_TYPES_FILE = {
    PDF: 'pdf',
    JPG: 'jpg',
    JPEG: 'jpeg',
    PNG: 'png'
}

const CHECK_TYPES_FILE = {
    PDF: 'PDF',
    XLS: 'XLS',
}

const FILE_SIZE = {
    MAX_FILE_SIZE: 5120
}

const FILE_NAME = {
    MAX_FILE_NAME: 255
}

const WHITE_LIST_CHARS = {
    CHARS: /^[a-z0-9|\-| |_|á|é|í|ó|ú|ñ|ä|ë|ï|ö|ü|ç]+\.[a-z0-9]{3,4}$/ig
}

const FILE_SIZE_EXTERNAL_TRANSFER = {
    MAX_FILE_SIZE: 20480
}

module.exports = {
    VALID_TYPES_FILE,
    CHECK_TYPES_FILE,
    FILE_SIZE,
    FILE_SIZE_EXTERNAL_TRANSFER,
    FILE_NAME,
    WHITE_LIST_CHARS,
    FILE_NUMBER_LIMIT: 1,
    FILE_SIZE_LIMIT_EXTERNAL_TRANSER: 20000,
    FILE_TYPES: ['pdf', 'jpeg', 'png'],
    FILE_DISCRIPTION_CHARS_LIMIT: 100,
    FILE_NAME_CHARS_LIMIT: 40,
    FILE_NAME_REGEX: /^[a-z0-9| |_|á|é|í|ó|ú|ñ|ä|ë|ï|ö|ü|ç]+\.[a-z0-9]{3,4}$/ig,
}
